import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";
import "../Souscription.css";
import { useHistory } from "react-router";
import contractService from "../../../services/contract/contractService";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Input,
  Label,
} from "reactstrap";
import Select from "react-select";

function NavBar({ onClickMenu, text ,addBtn}) {

  const idcustomer = JSON.parse(localStorage.getItem("user")).id
  const history = useHistory();
  const [listContratCarte, setListContratCarte] = useState(null);
  const [selectOptionContrat, setOptionSelectedContrat] = useState(null);
  const [optionContrat, setListOptionContrat] = useState([]);
  const [contractId, setContratId]= useState(null)
  const homeBtn = () => {
    history.push(`${process.env.PUBLIC_URL}`);
  };
  useEffect(()=>{
    contractService.getAllCarteContractsbyCustomer(idcustomer).then((res)=>{
      if(res.status == 200){
        setListContratCarte(res.data)
        console.log(listContratCarte);
      }
    })

  },[])

    const onchangeSelectContart =(item)=>{
      setOptionSelectedContrat(item)
      contractService.getContractbyId(item.value).then(res=>{
        setContratId(res.data)
      })
      
    }

    const [oppen, setOppen] = useState(false);
    const modaltoggle = () => {
      setOppen(!oppen);
    };
  return (
    <div className="row col-lg-12 col-md-12 col-sm-12 col-12 header-souscription">
      {onClickMenu && (
        <div className="col-2 d-flex-a-c" style={{justifyContent:"flex-end"}}>
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars color="white" onClick={onClickMenu} />
          </Link>
        </div>
      )}
      <div className="col-md-4 d-flex-a-c" style={{ paddingLeft: "30px",width: "40%", justifyContent:"flex-start" }}>
        
          <img
            style={{ width: "250px", cursor: "pointer" ,paddingTop : "5px"}}
            src={`${process.env.PUBLIC_URL}/assets/images/logo carte & garanty.png`}
            onClick={homeBtn}
          />
        
      </div>
      <div className="col-md-2 d-sous-a-c">
        <h6 style={{ color: "white", fontSize: "24px", fontWeight:"800" }}>{text}</h6>
      </div>
      <div className="col-md-3 d-flex-a-c">
        {/* {addBtn && <div
          style={{ display: "flex", cursor: "pointer" }}
          onClick={() => {
            setListOptionContrat(
              listContratCarte?.map((el) => ({
                value: el.idcontract,
                label:el.numero_carte_garanty

              }))
            );
            setOppen(true)
          }}
        >
          <h6 className="textaddequi" >Ajouter un équipement</h6>
          <img
            className="addcarteprd"
            src={`${process.env.PUBLIC_URL}/assets/images/add-product.svg`}
          />
        </div> } */}
      </div>
       <Modal
        isOpen={oppen}
        toggle={modaltoggle}
        centered
        style={{ display: "flex", justifyContent: "center", maxWidth: "750px" }}
      >
        <ModalHeader toggle={modaltoggle}>
          <div
            style={{
              font: "normal normal bold 25px/27px Century Gothic",
              color: "#0C015F",
            }}
          >
            {/* Before continuing, you must select your card */}
            Votre carte Assurmax ou Assurmax+
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="form-row">
            <Col md="8 mb-4" className="inputCarte">
              <Col
                md={{
                  size: 10,
                }}
              >
                <Label check className="text-popup">
                  Séléctionnez votre carte
                  {/* Select your card */}
                </Label>
                <Select
                  value={selectOptionContrat}
                  onChange={onchangeSelectContart}
                  options={optionContrat}
                />
              </Col>
            </Col>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={()=>{
              history.push({
            pathname: "/Souscription/Etape2",
            state: contractId,
            });
            }}
            className="calcule-btn"
            style={{ width: "30%" }}
          >
            Continuer
            {/* Next */}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default NavBar;
